export default "__VITE_ASSET__CuKZAq7m__"